import React, { useState, useEffect } from 'react';
import { Col, Row, Input, AutoComplete } from 'antd';
import { CloseSquareFilled } from '@ant-design/icons';
import ApiInterface from '../lib/ApiInterface.js';

const { Search } = Input;

const onSearch = (value) => console.log(value);

const mockVal = (str, repeat = 1) => ({
  value: str.repeat(repeat),
});

function HeaderContainer(props) {
  // const [value, setValue] = useState('');
  const [options, setOptions] = useState([]);
  const [regions, setRegions] = useState([]);
  const api = new ApiInterface();

  const getPanelValue = (searchText) => {
    console.log(searchText, '>>>>>>')
    // return !searchText ? [] : [mockVal(searchText), mockVal(searchText, 2), mockVal(searchText, 3)]
    if (searchText != "" && searchText != null && searchText.length >= 3) {
      api.geocord(`https://api.mapbox.com/geocoding/v5/mapbox.places/${searchText}.json`, {
        limit: 5,
        access_token: 'pk.eyJ1Ijoid3RnZW9ncmFwaGVyIiwiYSI6ImNrNXk3dXh6NzAwbncza3A1eHlpY2J2bmoifQ.JRy79QqtwUTYHK7dFUYy5g',
        language: 'en-US',
        country: 'US',
        types: "region,place,postcode,locality,neighborhood,address"
      }, function(res){
        if (res.features) {
          const regions = res.features.map(region => {
            return {
              value: region['place_name_en-US']
            }
          })
          setOptions(regions)
          setRegions(res.features)
        }
      })
    }

    return []
  }

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === '0') {
        var val = document.getElementById('address-search')?.value;
        console.log(val, '0 pressed');
        if (val) {
          val = val + '0'
        } else {
          val = '0';
        }
        props.setValue(val);
        setOptions(getPanelValue(val));
        e.preventDefault(); // allows input to receive it
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    // Cleanup when component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []); // empty dependency array ensures this runs only once

  const onSelect = (data) => {
    const region = regions.filter(region => region['place_name_en-US'] == data)

    if (region && region.length) {
      props.setRegion(region[0])
    }
    props.setIsMarker(true)
    console.log('onSelect: >>>', region);
  };
  const onChange = (data) => {
    props.setValue(data);
  };

  return (
    <div>
      <Row>
        <Col
          span={24}
        >
          <AutoComplete
            id='address-search'
            value={props.value}
            options={options}
            className='search-address'
            onSelect={onSelect}
            onSearch={(text) => {console.log('onSearch called with:', text);setOptions(getPanelValue(text))}}
            // allowClear={{ clearIcon: <CloseSquareFilled /> }}
            // onClear={() => {
            //   props.setIsMarker(false)
            // }}
            // allowClear
            placeholder="Search US Address..."
            onChange={onChange}
          >
            <Input
              allowClear={false} // disable default clear
              suffix={
                <CloseSquareFilled
                  onClick={() => {
                    props.setValue('');
                    props.setIsMarker(false);
                  }}
                  style={{ cursor: 'pointer', fontSize: '16px' }}
                />
              }
            />
          </AutoComplete>
        </Col>
      </Row>
    </div>
  );
}

export default HeaderContainer;
